<header
  class="fixed top-0 left-0 w-full z-50 bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800">
  <div class="px-4 sm:px-6 lg:px-8 mx-auto">
    <div class="flex items-center justify-between h-16">
      <div class="flex items-center">
        <div [routerLink]="'/dashboard'"
          class="flex items-center gap-2 text-gray-800 dark:text-white max-w-[222px] cursor-pointer">
          <img class="logo" src="https://estcdndev.blob.core.windows.net/document/Homepage/Images/logo-mini-new.svg"
            alt="logo">
          <h2 class="text-xl font-bold font-display leading-tight tracking-tight">Estater Docify</h2>
        </div>
        <nav class="hidden md:flex items-center gap-2 ml-4">
          <!-- Dashboard -->
          <a [routerLink]="'/dashboard'" routerLinkActive="bg-primary/10 text-primary font-medium"
            [routerLinkActiveOptions]="{ exact: true }"
            class="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-600 dark:text-gray-300 dark:hover:bg-card-dark dark:hover:text-white transition-colors cursor-pointer">
            <span class="material-symbols-outlined text-base">dashboard</span>
            <span>Dashboard</span>
          </a>

          <!-- Projects -->
          <a [routerLink]="'/content/estater-admin'" [ngClass]="{ 'bg-primary/10 text-primary font-medium': isContentRouteActive() }"
            class="flex items-center gap-2 px-3 py-2 rounded-lg text-gray-600 dark:text-gray-300 dark:hover:bg-card-dark dark:hover:text-white transition-colors cursor-pointer">
            <span class="material-symbols-outlined text-base">widgets</span>
            <span>Projects</span>
          </a>
        </nav>
      </div>

      <div class="flex items-center gap-4 relative">
        <!-- Search Bar -->
        <!-- <label *ngIf="showSearchBar" class="flex flex-col">
          <div class="relative flex w-full items-center">
            <span class="material-symbols-outlined absolute left-3 text-gray-500 dark:text-gray-400">search</span>
            <input
              class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-full text-gray-800 dark:text-white bg-gray-100 dark:bg-card-dark focus:outline-0 focus:ring-2 focus:ring-primary h-10 placeholder:text-gray-500 dark:placeholder:text-gray-400 pl-10 pr-4 text-sm font-normal leading-normal border-transparent focus:border-primary shadow-sm"
              placeholder="Quick Search..." value="" />
          </div>
        </label> -->

        <!-- Mobile Menu Button -->
        <button *ngIf="showMobileMenuButton()"
          class="w-10 h-10 flex md:hidden items-center justify-center rounded-full hover:bg-gray-100 dark:hover:bg-card-dark transition-colors" (click)="toggleMobileMenu()">
          <span class="material-symbols-outlined text-2xl text-gray-600 dark:text-gray-300">menu</span>
        </button>

        <!-- Upload Button -->
        <button [routerLink]="'/upload'"
          class="hidden sm:flex items-center justify-center gap-2 rounded-full h-10 px-4 bg-success text-white text-sm font-bold hover:bg-success/90 transition-all duration-300 transform hover:scale-105 btn-glow-success cursor-pointer">
          <span class="material-symbols-outlined text-base">upload</span>
          <span>Upload</span>
        </button>

        <!-- Notifications -->
        <!-- <span
          class="material-symbols-outlined text-2xl cursor-pointer text-gray-600 dark:text-gray-300 hover:text-primary transition-colors">
          notifications
        </span> -->

        <!-- Profile Dropdown -->
        <div class="relative">
          <!-- Profile Button -->
          <button
            (click)="toggleProfileDropdown()"
            class="flex items-center gap-2 rounded-full cursor-pointer focus:outline-none"
          >
            <img [src]="userProfileImage" alt="profile" class="w-8 h-8 rounded-full border-2 border-primary/50" />
            <span class="hidden sm:block">{{ userFirstName }}</span>
            <span class="material-symbols-outlined text-base">expand_more</span>
          </button>

          <!-- Dropdown Menu -->
          <div
            *ngIf="profileDropdownOpen"
            class="absolute right-0 mt-2 w-40 bg-white dark:bg-gray-800 shadow-lg rounded-md py-2 z-50"
          >
            <button
              (click)="logout()"
              class="w-full text-left px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
